import { useState, useEffect } from 'react'
import { DataContainer, BankDataContainer, HistoryContainer } from './styled'
import { AccountBankChange, Input, Button } from '@sabavision/dio'
// import { getIbanWithCardNumRequest } from '../../api/external'
import { getListBankDetailsRequest, createBankDetailRequest } from '../../api/profile'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { updateToastData } from '../../actions/toast'

// validations
import { validateWidthUndefined } from '../../validations'
import financial from '../../validations/schema/financial'

function Financial() {
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  const dispatch = useDispatch()
  const { userId } = useParams()

  const cardFormat = {
    numericOnly: true,
    delimiter: '-',
    blocks: [4, 4, 4, 4]
  }

  const shebaFormat = {
    numericOnly: true,
    prefix: 'IR',
    delimiter: ' ',
    blocks: [2, 2, 4, 4, 4, 4, 4, 2],
    uppercase: true
  }

  const [bankInputStatus, setBankInputStatus] = useState<boolean>(true)
  const [bankDetails, setBankDetails] = useState<any[]>([])
  const [bankDetail, setBankDetail] = useState<any>({
    bank_account_number: null,
    bank_account_owner: null,
    bank_card_number: null,
    bank_iban: null,
    bank_name: null
  })

  // errors
  const [errors, setErrors] = useState<any>(null)

  useEffect(() => {
    handleGetListBankDetailsRequest()
  }, [])

  // const handleGetIbanWithCardNumRequest = (cardNum: number) => {
  //   const data = {
  //     card_no: Number(cardNum),
  //     owner_name: 'مرتضی شریفی نیا'
  //   }
  //   getIbanWithCardNumRequest(userId, data, (response: any) => {
  //     const temp = {
  //       bank_account_number: response.data.deposit,
  //       bank_account_owner: response.data.owners,
  //       bank_card_number: response.data.card_no,
  //       bank_iban: response.data.iban,
  //       bank_name: response.data.bank_name
  //     }

  //     setBankDetail({ ...temp })
  //     setBankCardLoading(false)
  //   }, (error: any) => {
  //     console.log(error)
  //     setBankCardLoading(false)
  //   })
  // }

  const handleGetListBankDetailsRequest = () => {
    getListBankDetailsRequest(
      userId,
      {},
      (response: any) => {
        setBankDetails(response.data)
      },
      (error: any) => {
        dispatch(
          updateToastData({
            message: error.response?.data?.message,
            type: 'error'
          })
        )
      }
    )
  }

  const handleCreateBankDetailRequest = () => {
    const hasError = validationData()

    if (!hasError) {
      createBankDetailRequest(
        userId,
        bankDetail,
        () => {
          handleGetListBankDetailsRequest()
          setBankDetail({
            bank_account_number: null,
            bank_account_owner: null,
            bank_card_number: null,
            bank_iban: null,
            bank_name: null
          })
          dispatch(
            updateToastData({
              message: t('toasts.update_financial.success'),
              type: 'success'
            })
          )
        },
        (error: any) => {
          dispatch(
            updateToastData({
              message: error.response?.data?.message,
              type: 'error'
            })
          )
        }
      )
    }
  }

  const changeBankInputStatus = (v: boolean) => {
    setBankInputStatus(v)
    setBankDetail({
      bank_account_number: null,
      bank_account_owner: null,
      bank_card_number: null,
      bank_iban: null,
      bank_name: null
    })
    setErrors(null)
  }

  const validationData = () => {
    const constrains = financial()
    let error = null

    // value
    const sheba = bankDetail.bank_iban ? bankDetail.bank_iban : undefined
    const cardNum = bankDetail.bank_card_number ? bankDetail.bank_card_number : undefined

    // validation
    const shebaErr = validateWidthUndefined({ bank_iban: sheba }, 'bank_iban', constrains)
    const cardNumErr = validateWidthUndefined({ bank_card_number: cardNum }, 'bank_card_number', constrains)

    // error
    if (shebaErr || cardNumErr) {
      error = {
        sheba: shebaErr && t(shebaErr),
        cardNum: cardNumErr && t(cardNumErr)
      }
    } else {
      error = null
    }

    if (error) {
      const tempError: any = error
      const errorMessages = Object.keys(tempError)

      errorMessages.forEach((item: string) => {
        if (tempError[item]) {
          dispatch(
            updateToastData({
              message: tempError[item],
              type: 'error'
            })
          )
        }
      })
    }

    setErrors({ ...error })
    return !!error
  }

  return (
    <DataContainer>
      <div className="max-container">
        <BankDataContainer>
          <div>
            {bankInputStatus ? (
              <Input
                key="iban_input"
                handleChange={(v) => {
                  setBankDetail({ ...bankDetail, bank_iban: v })
                }}
                label={t('sheba_number')}
                type="profile"
                name="Iban"
                dir="ltr"
                showErrorMessage={false}
                error={errors?.sheba}
                formatingOptions={shebaFormat}
              />
            ) : (
              <Input
                key="card_input"
                handleChange={(v) => {
                  setBankDetail({ ...bankDetail, bank_card_number: v })
                }}
                label={t('card_number')}
                type="profile"
                name="card"
                dir="ltr"
                showErrorMessage={false}
                error={errors?.cardNum}
                formatingOptions={cardFormat}
              />
            )}

            {!bankInputStatus ? (
              <span
                className="bank-input-status"
                onClick={() => {
                  changeBankInputStatus(true)
                }}
              >
                {t('use_sheba_number')}
              </span>
            ) : (
              <span
                className="bank-input-status"
                onClick={() => {
                  changeBankInputStatus(false)
                }}
              >
                {t('use_card_number')}
              </span>
            )}
          </div>

          {/* <BankCard
            isLoading={bankCardLoading}
            disabled={bankCardLoading}
            accountHolder={bankDetail.bank_account_owner}
            bankName={bankDetail.bank_name}
            bankLogoURL={bankDetail.bank_name ? `https://plus.sabavision.com/public/dio/statics/images/bank-logo/${bankDetail.bank_name}.svg` : undefined }
            resetValue={!bankDetail.bank_iban}
            handleChange={(v) => { handleCardNumberChange(String(v)) }}
            handlePressEnter={(v) => { console.log(v) }}
          /> */}

          <Button
            data-test="button-financial-data"
            label={t('confirm')}
            fullWidth
            radius="10px"
            fontSize="12px"
            handleClick={handleCreateBankDetailRequest}
          />
        </BankDataContainer>
      </div>

      <span className="divider">
        <span>
          <span className="iconsax-cards"></span>
          <span>{t('change_bank_history')}</span>
        </span>
      </span>

      <div style={{ width: '95%' }}>
        <HistoryContainer>
          {bankDetails.map((item) => (
            <AccountBankChange
              key={item.created_at}
              bankName={item.bank_name}
              sheba={item.bank_iban?.replace('IR', '')}
              cardNum={item.bank_card_number}
              changeDate={item.created_at}
            />
          ))}
        </HistoryContainer>
      </div>
    </DataContainer>
  )
}

export default Financial
